import { HcaptchaClass } from '../../components/descope-hcaptcha/HcaptchaClass';

const vars = HcaptchaClass.cssVarList;

const hcaptcha = {
  enabled: {
    false: {
      [vars.maxHeight]: '70px',
    },
  },
};

export default hcaptcha;
export { vars };
